import qs from 'qs'
import CommonService from '@/services/oidcLoginService/Common'

const commonHandler = {
  /**
   * @description 人事列表获取审批单类型
   * @param {String} name 审批单名字
   */
  getFormType(name) {
    console.log(window.commonConfig.formTypes)
    const formTypes = window.commonConfig.formTypes
    const matchType = _.find(formTypes, (type) => {
      return _.includes([type.name, type.alias], name)
    })
    return matchType ? matchType.type : 0
  },
  /**
   * @description 我的流程获取审批单类型
   * @param {String} name 审批单名字
   */
  getMyworkFormType(name) {
    const formTypes = window.commonConfig.formTypes
    const matchType = _.find(formTypes, (type) => {
      return _.includes([type.name, type.myworkTypeName], name)
    })
    return matchType ? matchType.type : 0
  },
  /**
   * @description:判断系统数据是否来自旧系统
   * @param {String} id 业务id
   * @param {Number} type 审批单类型
   */
  async isOldData(id, type) {
    const res = await CommonService.isOldData({
      id,
      type,
    })
    if (res && res.code === 0) {
      return res.msg === 'true'
    }
    return false
  },
  /**
   * @description:打开旧系统审批
   * @param {String} userid 登录用户id
   * @param {String} instanceid 业务id
   * @param {Number} type 审批单类型
   */
  openOldForm(userid, instanceid, type) {
    const params = {
      RelyUserId: userid,
      id: instanceid,
      type,
    }
    window.open(`${currentEnv.VUE_APP_OLDHR_PAGE}/Login/GoToFormDetail?${qs.stringify(params)}`)
  },
  /**
   * @description:打开旧系统工作流程
   * @param {String} userid 登录用户id
   * @param {String} instanceid 业务id
   * @param {Number} type 审批单类型
   */
  openOldWorkflow(userid, instanceid, type) {
    const params = {
      RelyUserId: userid,
      id: instanceid,
      type,
    }
    window.open(`${currentEnv.VUE_APP_OLDHR_PAGE}/Login/GoToWorkFlow?${qs.stringify(params)}`)
  },
  /**
   * @description:获取部门权限数据
   * @param {String} moduleName 模块名
   * @param {String} date 日期
   */
  async getAuthDeparts(moduleName, date = dayjs(new Date()).format('YYYY-MM-DD')) {
    const res = await CommonService.getAuthDeparts({
      menuName: encodeURIComponent(moduleName),
      date,
    })
    if (res && res.code === 0) {
      return res.data
    }
    return []
  },
  /**
   * @description:获取人员权限数据
   * @param {String} moduleName 模块名
   * @param {String} date 日期
   */
  async getAuthUsers(moduleName, date = dayjs(new Date()).format('YYYY-MM-DD')) {
    const res = await CommonService.getAuthUsers({
      menuName: encodeURIComponent(moduleName),
      date,
    })
    if (res && res.code === 0) {
      return res.data
    }
    return []
  },
}

const install = (Vue) => {
  Vue.prototype.$globalFn = commonHandler
}
export default { install }
